import { Tabs } from 'uikit';

import { useCallback, useMemo } from 'react';

export const ActKC2GroupTypeSelector = <TTabs extends { id: null | TId; label: string } = any, TId = any>({
    tabElements,
    onChange,
    activeTabItem,
}: {
    tabElements: TTabs[];
    onChange: (value: TTabs) => void;
    activeTabItem: TTabs | null;
}) => {
    const tabChangeHandler = useCallback<({ value }: { value: (typeof tabElements)[0] }) => void>(
        ({ value }) => {
            onChange(value);
        },
        [onChange],
    );

    const value = useMemo(
        () => tabElements.find(({ id }) => id === activeTabItem?.id) ?? tabElements[0],
        [activeTabItem?.id, tabElements],
    );

    return <Tabs value={value} items={tabElements} onChange={tabChangeHandler} size="s" linePosition="bottom" />;
};

ActKC2GroupTypeSelector.displayName = 'GroupTypeSelector';
